import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import membersService from '../../Services/membersService';

export const fetchFamilyMembers = createAsyncThunk(
  'familyMembers/fetchFamilyMembers',
  async () => {
    const response = await membersService.list({ page: 1, limit: 1000 });
    return response.allMembers || response.members || [];
  }
);

const familyMembersSlice = createSlice({
  name: 'familyMembers',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFamilyMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFamilyMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFamilyMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default familyMembersSlice.reducer;
